import { ystrRequired } from "src/utils";
import * as Yup from "yup";

export const useModalPlateBirthValidationSchema = () => {
  const schema = Yup.object().shape({
    plate: ystrRequired,
  });

  return { schema };
};
